import { useState, } from 'react';
import dayjs from 'dayjs';
import ButtonWhatsApp from '../components/ButtonComponent/ButtonWhatsApp';
import { i18n } from '../lang/i18n';
import { LogoDark } from '../common/Conf';
import { useAppSelector } from '../store/hooks';
const Cookies = require("js-cookie");

interface Props { instanceCode: string }
export default function FooterMain(props: Props) {
    const appConf = useAppSelector((state) => state.appConf)
	const [showCookiesMessage, setSearchingActive] = useState(Cookies.get('rch-cks') === undefined)

	function onCookiesAccept() {
		let expires = new Date();
		expires.setMonth(expires.getMonth() + 12)
		Cookies.set('rch-cks', "ok", { expires: expires });
		setSearchingActive(false);
	}

	return (
		<footer className="footer">
			<div className="container footer-main">
				<div className="row">
					<img src={LogoDark(props.instanceCode,'500')} alt="" style={{maxWidth:'500px', width:'80%'}}/>
				</div>
				<div className="row text-center mt-5">
					<div className="col-12">
						<h3>{appConf.slogan}</h3>
					</div>
					<div className="col-12 text-center mb-3 mt-3">
						<ButtonWhatsApp />
					</div>
				</div>
			</div>
			<div className="container footer-by">
				<div className="row">
					<div className="col text-center">
						<span translate='no'>@{dayjs().format('YYYY')} by RoS app</span>
					</div>
				</div>
			</div>
			{showCookiesMessage && <div className="footer-cookies" onClick={onCookiesAccept}>
				<div>{i18n._MSG.Cookies}</div>
				<div className="pl-2">
					<button onClick={onCookiesAccept} className="btn btn-outline-light" >{i18n._BTNs.Accept}</button>
				</div>
			</div>}
		</footer>
	);
}